import React from 'react'
import { useHistory } from 'react-router-dom'

import { NAVIGATOR } from '@utils/constants'
import Button from './Button'
import { useTranslation } from 'react-i18next'
import PageNotFoundImg from '@images/page_not_found.png'

export default function PageNotFound() {
  const history = useHistory()
  const { t } = useTranslation()
  return (
    <div className="error-page">
      <img src={PageNotFoundImg} alt={t('PageNotFound')} />
      <p className="error-page__msg">
        <span
          dangerouslySetInnerHTML={{
            __html: `${t('PageNotFound')}`,
          }}
        ></span>
      </p>
      <Button onClick={() => history.push(NAVIGATOR.main.path)}>{t('ToHomePage')}</Button>
    </div>
  )
}
